import { render, staticRenderFns } from "./VirtualServerSsdCloudService.vue?vue&type=template&id=01ee8875&"
import script from "./VirtualServerSsdCloudService.vue?vue&type=script&lang=js&"
export * from "./VirtualServerSsdCloudService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports